import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { icoInfoCircle, IconsModule } from '../icons';
import { TooltipInfoIconComponent } from './tooltip-info-icon/tooltip-info-icon.component';
import { TooltipDirective } from './tooltip.directive';

@NgModule({
  declarations: [TooltipDirective, TooltipInfoIconComponent],
  imports: [CommonModule, NgbTooltipModule, IconsModule.withIcons(icoInfoCircle)],
  exports: [TooltipDirective, TooltipInfoIconComponent]
})
export class TooltipModule {}
